function getCurrentMonthUnixRange() {
  const today = new Date();
  const firstDay = new Date(
    Date.UTC(today.getFullYear(), today.getMonth(), 1, 0, 0, 0),
  );
  const lastDay = new Date(
    Date.UTC(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59),
  );
  const firstDayUnix = Math.floor(firstDay.getTime() / 1000);
  const lastDayUnix = Math.floor(lastDay.getTime() / 1000);

  return {
    _gte: firstDayUnix,
    _lte: lastDayUnix,
  };
}
export const dateRange = getCurrentMonthUnixRange();
